<form [formGroup]="form" (ngSubmit)="export()">
  <h1 mat-dialog-title>Exportación ERP</h1>
  <div mat-dialog-content>
    <mat-form-field class="medium-width margin-right-small">
      <input matInput autocomplete="off" formControlName="from" [matDatepicker]="pickerFrom" placeholder="Fecha desde" required>
      <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
      <mat-datepicker #pickerFrom></mat-datepicker>
      <mat-error *ngIf="f.from.errors && f.from.errors.required">
          Ingrese la fecha desde
      </mat-error>
  </mat-form-field>
  <mat-form-field class="medium-width">
      <input matInput autocomplete="off" formControlName="to" [matDatepicker]="pickerTo" placeholder="Fecha hasta" required>
      <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
      <mat-datepicker #pickerTo></mat-datepicker>
      <mat-error *ngIf="f.to.errors && f.to.errors.required">
          Ingrese la fecha hasta
      </mat-error>
  </mat-form-field>
  </div>
  <div class="clearfix">
      <div class="pull-right">
          <button [disabled]="loading" mat-button type="submit">Exportar</button>
          <button [disabled]="loading" mat-button type="button" cdkFocusInitial (click)="onNoClick()">Salir</button>
      </div>
  </div>
</form>
